import { CreditCard } from "@mui/icons-material";
import type { StaticImageData } from "next/image";
import Image from "next/image";
import VisaIcon from "../../assets/icons/visa.svg";
import AmexIcon from "../../assets/icons/american-express.svg";
import MastercardIcon from "../../assets/icons/mastercard.svg";
import DiscoverIcon from "../../assets/icons/discover.svg";
import DinersClubIcon from "../../assets/icons/diners-club.svg";

const cardIcons: Record<string, StaticImageData> = {
  visa: VisaIcon as StaticImageData,
  master_card: MastercardIcon as StaticImageData,
  amex: AmexIcon as StaticImageData,
  discover: DiscoverIcon as StaticImageData,
  diners_club: DinersClubIcon as StaticImageData,
};
export const CreditCardIcon = ({
  cardBrand,
  height = 24,
  width = 24,
}: {
  cardBrand: string;
  height: number;
  width: number;
}) => {
  if (!cardBrand) return <CreditCard color="inherit" />;

  const Icon = cardIcons[cardBrand] as StaticImageData | undefined;

  if (!Icon) {
    return <CreditCard />;
  }

  return (
    <Image
      alt={`${cardBrand} icon`}
      height={height}
      src={Icon.src}
      style={{ width, height, objectFit: "cover" }}
      width={width}
    />
  );
};
